/**
 * The initial values for the redux state.
 */
export const INITIAL_STATE = {
    showCookieOverlay: true,
    performanceCookies: false,
    functionalCookies: false,
    targetingCookies: false,
};
